import { render, staticRenderFns } from "./subscriptionCenter.vue?vue&type=template&id=73080cea&scoped=true&"
import script from "./subscriptionCenter.vue?vue&type=script&lang=js&"
export * from "./subscriptionCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73080cea",
  null
  
)

export default component.exports